import * as React from "react";
import { SVGProps } from "react";
const SvgProfileLoggedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.5 19a6.474 6.474 0 0 1 6.5 6.5 6.5 6.5 0 1 1-6.5-6.5ZM17 14a4.006 4.006 0 0 1 3.867 3.032c-.669.046-1.33.17-1.969.371A2 2 0 0 0 17 16H7a2.006 2.006 0 0 0-2 2v10a1 1 0 1 1-2 0V18a4.012 4.012 0 0 1 4-4h10Zm8.695 8.805a1 1 0 0 0-1.402-.012L20.5 26.586l-1.793-1.793a1 1 0 0 0-1.414 1.414l2.5 2.5a1 1 0 0 0 1.414 0l4.5-4.5a1 1 0 0 0-.012-1.402ZM12 3a4.5 4.5 0 1 1 0 9 4.481 4.481 0 0 1-4.5-4.5A4.5 4.5 0 0 1 12 3Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgProfileLoggedIn;
